export default class LivestreamAffiliateStorageConstants {
    public static readonly REFS_LOCAL_STORAGE_KEY = 'livestream_affiliate_refs';

    public static buildSessionTrackKey(productId: number, ref: string): string {
        return `tracked_view_${productId}_${ref}`;
    }
}
